import { buildPolicyHook, useCurrentUserDataLifecycle } from 'policy-lib';
import { EnrichmentPolicy } from './EnrichmentPolicy';
import { useEnrichmentSettings } from '../EnrichmentSettingsProvider';
const useBaseEnrichmentPolicy = buildPolicyHook(EnrichmentPolicy);

/**
 * Get access to the enrichment policy tied to the current user.
 *
 * @returns {object} {EnrichmentPolicy, refresh}
 */
export function useEnrichmentPolicyNext() {
  const {
    settings,
    isLoaded
  } = useEnrichmentSettings();
  const {
    refresh,
    isRefreshing
  } = useCurrentUserDataLifecycle();
  const policy = useBaseEnrichmentPolicy({
    settings,
    isLoaded
  });
  return {
    policy,
    refresh,
    isRefreshing
  };
}